import { memo } from "react";

import AppLayoutDto from "dto/components/app-layout-dto";

import AppHeader from "components/app-header";
import AppSideNav from "components/app-side-nav";

const AppLayout = ({ children }: AppLayoutDto) => {
	return (
		<div className="app-layout">
			<main className="layout">
				<div className="layout__sidebar">
					<AppSideNav />
				</div>

				<div id="layout-container" className="layout__container">
					<AppHeader />

					<div className="layout__content">
						<div id="layout-children" className="layout__page">
							{children}
						</div>
					</div>
				</div>
			</main>
		</div>
	);
};

export default memo(AppLayout);
